import { useState, useEffect, useCallback } from 'react';

const carouselItems = [
  {
    tag: '独家爆料',
    title: '顶流男星深夜私会，酒店监控拍下全程',
    summary: '据知情人士透露，该男星与神秘女子同框画面已被酒店监控完整记录，双方工作室暂未回应。',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20breaking%20story%20visual%2C%20warm%20atmospheric%20lighting%2C%20abstract%20representation%20of%20celebrity%20gossip%2C%20luxury%20hotel%20aesthetic%2C%20coral%20and%20golden%20tone%2C%20editorial%20magazine%20cover%20style%2C%20clean%20composition&width=640&height=440&seq=carousel-slide-01&orientation=landscape'
  },
  {
    tag: '网红翻车',
    title: '千万粉主播直播翻车，意外曝光签约黑幕',
    summary: '直播间口误引发连锁反应，多名业内人士爆料该主播团队存在严重合约问题，引发全网热议。',
    img: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20dramatic%20red%20alert%20visual%2C%20modern%20broadcast%20setup%2C%20controversy%20theme%2C%20warm%20coral%20and%20amber%20lighting%2C%20breaking%20news%20aesthetic%2C%20clean%20editorial%20composition&width=640&height=440&seq=carousel-slide-02&orientation=landscape'
  },
  {
    tag: '综艺争议',
    title: '热门选秀节目黑幕曝光，导师团内部不和',
    summary: '节目组内部人士匿名爆料，多位导师因赛制问题产生严重分歧，节目组被迫紧急调整方案。',
    img: 'https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20dramatic%20spotlight%20and%20tension%2C%20reality%20TV%20drama%20atmosphere%2C%20warm%20golden%20and%20coral%20stage%20lighting%2C%20entertainment%20industry%20aesthetic%2C%20clean%20composition&width=640&height=440&seq=carousel-slide-03&orientation=landscape'
  },
  {
    tag: '恋情实锤',
    title: '当红小花与圈外男友被拍，恋情终于实锤',
    summary: '粉丝拍到两人同游三亚的亲密照片，男方身份被扒出竟为知名企业高管，引发网友热议。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20tropical%20beach%20scene%20with%20warm%20sunset%20light%2C%20paparazzi%20style%20photography%20aesthetic%2C%20coral%20and%20golden%20tones%2C%20soft%20dreamy%20atmosphere%2C%20entertainment%20news%20visual%2C%20clean%20composition&width=640&height=440&seq=carousel-slide-04&orientation=landscape'
  },
  {
    tag: '行业深扒',
    title: '娱乐圈潜规则再曝光，多位艺人牵扯其中',
    summary: '调查记者历时三个月深入挖掘，揭露娱乐圈不为人知的运作模式，涉及多家知名经纪公司。',
    img: 'https://readdy.ai/api/search-image?query=Investigative%20journalism%20visual%20with%20dramatic%20shadow%20and%20light%20contrast%2C%20mysterious%20atmosphere%2C%20warm%20coral%20and%20deep%20amber%20tones%2C%20news%20expose%20aesthetic%2C%20editorial%20magazine%20style%2C%20clean%20composition&width=640&height=440&seq=carousel-slide-05&orientation=landscape'
  },
];

export default function CarouselSection() {
  const [current, setCurrent] = useState(0);
  const total = carouselItems.length;

  const goNext = useCallback(() => setCurrent((prev) => (prev + 1) % total), [total]);
  const goPrev = useCallback(() => setCurrent((prev) => (prev - 1 + total) % total), [total]);

  useEffect(() => {
    const timer = setInterval(goNext, 4500);
    return () => clearInterval(timer);
  }, [goNext]);

  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-12">
          <span className="inline-block text-xs font-label tracking-wider text-primary-600 bg-primary-100 px-4 py-1.5 rounded-full mb-4 whitespace-nowrap">
            编辑精选
          </span>
          <h2 className="font-heading text-[32px] md:text-[40px] text-foreground-950">热门推荐</h2>
          <p className="text-sm text-foreground-500 mt-3">编辑团队精心挑选的必看内容，不容错过的精彩爆料</p>
        </div>

        <div className="relative overflow-hidden rounded-3xl bg-background-100">
          <div className="relative w-full aspect-[21/10] md:aspect-[21/9] min-h-[380px] md:min-h-[440px]">
            {carouselItems.map((item, i) => (
              <div
                key={i}
                className={`absolute inset-0 flex flex-col md:flex-row transition-all duration-700 ease-in-out ${
                  i === current ? 'opacity-100 translate-x-0 z-10' : 'opacity-0 translate-x-8 z-0'
                }`}
              >
                <div className="w-full md:w-[45%] flex flex-col justify-center p-6 md:p-10 lg:p-14 bg-background-50">
                  <span className="inline-block text-xs font-label tracking-wider text-primary-600 bg-primary-100 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className="font-heading text-xl md:text-2xl lg:text-[28px] text-foreground-950 leading-tight mb-3">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">{item.summary}</p>
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer">
                    阅读全文 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
                <div className="w-full md:w-[55%] h-[200px] md:h-auto">
                  <img
                    src={item.img}
                    alt={item.title}
                    title={`51吃瓜网 ${item.title}`}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            ))}
          </div>

          <button
            onClick={goPrev}
            className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-20 w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-50/90 flex items-center justify-center hover:bg-background-50 transition-all cursor-pointer"
            aria-label="上一张"
          >
            <i className="ri-arrow-left-s-line text-xl text-foreground-800"></i>
          </button>
          <button
            onClick={goNext}
            className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-20 w-10 h-10 md:w-12 md:h-12 rounded-full bg-background-50/90 flex items-center justify-center hover:bg-background-50 transition-all cursor-pointer"
            aria-label="下一张"
          >
            <i className="ri-arrow-right-s-line text-xl text-foreground-800"></i>
          </button>

          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex gap-2">
            {carouselItems.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  i === current ? 'bg-primary-500 w-6' : 'bg-foreground-300 hover:bg-foreground-400'
                }`}
                aria-label={`跳转到第${i + 1}张`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}